import { render, staticRenderFns } from "./kcp-pay.vue?vue&type=template&id=c8167db4&"
import script from "./kcp-pay.vue?vue&type=script&lang=js&"
export * from "./kcp-pay.vue?vue&type=script&lang=js&"
import style0 from "./kcp-pay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports